import React,{useState} from 'react';
import {DialogContent,Typography,Paper,Dialog,IconButton} from '@material-ui/core';
import Draggable from 'react-draggable';
import {paperPropsSmall } from '../../../css/muiStyle';
import {Close} from '@material-ui/icons';
import '../../../css/compte.css'
import { withStyles} from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Personn from "../../../img/icons/person.svg"
import { useContext } from 'react';
import ParamContext from '../../../Contexte';


const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle  className={classes.root} {...other}>
        <Typography >{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <Close />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

//Add a new role
function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  )
}

export default function Cpt_new_pass(props) {
  const param=useContext(ParamContext);
  const [open,setOpen]=useState(false)

  const handleClickOpen = () => { 
        setOpen(true); 
  };

  const handleClose = () => { setOpen(false); };

  return (
    <div>
      <img src={param.userProfileImg+"/"+props.id+'.jpg'} style={{cursor:'pointer'}}
           className='client-profile-img' alt='Photo de profil' onClick={handleClickOpen}
           onError={(e) => {
           e.target.onerror = null
           e.target.src = Personn }}/>
      <Dialog 
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            PaperProps={paperPropsSmall}
       >
           <DialogTitle id="simple-dialog-title" onClose={handleClose}/>
            <DialogContent>
              <div className="div-profile">
                <img src={param.userProfileImg+"/"+props.id+'.jpg'} style={{cursor:'pointer'}}
                     className='img-profil' alt='Photo de profil' onClick={handleClickOpen}
                     onError={(e) => {
                     e.target.onerror = null
                     e.target.src = Personn }}/>
              </div>
            </DialogContent>
      </Dialog>
      </div>
  );
}
